/**
 * The maximum number of connected accounts allowed
 */
export const maxNumberConnectedAccount = 1;
